var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicTipEmojis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.23 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;fill-rule:evenodd;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#f6f7f8;}.cls-8{font-size:10px;font-family:Muli;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(125.66 2.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 66,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(125.66 2.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 65.08,
    height: 39.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(125.66 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.5,28a2,2,0,0,1-2-2V4.5a2,2,0,0,1,2-2H59.58a2,2,0,0,1,2,2V26a2,2,0,0,1-2,2H38.15l-3.5,4.72a2,2,0,0,1-2.8.42,2.09,2.09,0,0,1-.42-.42L27.93,28Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    x: 125.66,
    y: 2.5,
    width: 66,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAoCAYAAABKOyzUAAAACXBIWXMAAAsSAAALEgHS3X78AAACSElEQVRoQ+2a4ZLiIBCEe9S9e//HXXUz+4PppCHEPZVNHSm6aipRMTJfGmINmLtjS2Zmmx92KH+QrPGzImmLyNqiP9USd32fcMzdFQIBnOS8RwA1ucQk53B3v0hDAjhL8L3epQC+IiYsQEAQCuEj4oIFRu+uUAg3APc4zq4oHUEQf7HA4DDpWY4E4Y7F4XSEAfBLzA+lI/5EfOA4Q2NCcgFQDBEzs5ojzkhO0OHRuwgCSMmfkD8QXOcIdQbjLF/oWXxcam5ZTlu2tyJ6V5mP/l0AsAZxlMSf1hEmwiYaIEIDRGiACA0QoQEiNECEBojQABEaIEIDRGiACA0QoQEiVILIav4H0o85aakOWNf9Wd5qVaN45jo/dv4JMReN7KYThC5+sKh5R9Tz8FwCj/QvlS8vooWYvK5pVEGwMRvekDo6oU3NslYP5WtK3VjetXeBaBX7hiXPZV3D3d3M1A3X+PKEBKpF+Y5Ja5Wc1fETcgj3iFVn35BemzDmVS5d8mPDL3nNsndLEFwmqCXGjl6R37m5w29InaagV0t+bMw7wC9UK74vSEHwNyie042fcbwi9YET9qtyOdaGHoA1CG3cwgkUQdQgcIjQDZ8RLR1BeRGzLkAaI7I1QBu1AgEsc4GqBkLdUIJ7V9m1dOPI7IiN3SRNOhGQaxafkEBwWHJ+0DH8cKdLK5V/qH5F4Tggh8Hk+Qjlf5fMCXtAAHYCIeL8w3OC0LlpfmTuBQHAsodqD1W2KJVzUDaRHRYEgNqmNWpzIttDu4P4X/UNECQrbJd8gEgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-123.66,28a2,2,0,0,1-2-2V4.5a2,2,0,0,1,2-2h53.08a2,2,0,0,1,2,2V26a2,2,0,0,1-2,2H-92l-3.5,4.72a2,2,0,0,1-2.8.42,1.81,1.81,0,0,1-.41-.42l-3.5-4.72Z",
    transform: "translate(125.66 2.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 125.16,
    width: 67.08,
    height: 41.04
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(143.14 20.65)"
  }, "Emojis")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicTipEmojis);
export default __webpack_public_path__ + "static/media/TopicTip_Emojis.6fbb68bad56e49a53035904ef335ed0a.svg";
export { ForwardRef as ReactComponent };